import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class DirectusEditPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    collectionsByDirectus: [],
    collectionsByexternaldb: [],
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { dbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForDirectus({ projectId, externalDbUuid: dbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
    const { externalDbDirectus, collectionList } = this.props.dataConnector;
    const { completeData } = externalDbDirectus;
    // this.setState({ collectionsByDirectus: completeData.tables });
    // this.setState({ collectionsByexternaldb: collectionList });
    this.setState({
      collectionsByDirectus: completeData.tables,
      collectionsByexternaldb: collectionList,
    });
  }
  handleCreateCollection = (index) => {
    const { match, history } = this.props;
    const { dbUuid, projectId, version } = match.params;
    history.push(`/data-connector/${version}/v/${projectId}/directus-datasource/${dbUuid}/create`, {
      collectionIndex: index,
    });
  };
  handleUpdateCollection = (item) => {
    const { match, history } = this.props;
    const { projectId, dbUuid, version } = match.params;
    history.push(
      `/data-connector/${version}/v/${projectId}/directus-edit/${dbUuid}/update/${item.name}`,
    );
  };
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };

  renderCollectionCards = (item, index) => {
    const { collectionsByexternaldb } = this.state;
    const name = item.name;
    const matchingObject =
      collectionsByexternaldb &&
      collectionsByexternaldb.find((obj) => obj.orgCollectionName === name);
    return (
      <span className={`card  ml-4 col-lg-4 d-flex`} key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject && matchingObject ? (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name}
              </h5>
            )}
            {item.fields ? (
              <p>Number of fields: {Object.keys(item.fields).length}</p>
            ) : (
              <p>Number of fields:0</p>
            )}
            {matchingObject && matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
            {matchingObject && matchingObject ? (
              <button
                className="btn btn-theme-submit btn-md"
                onClick={() => this.handleUpdateCollection(item)}
              >
                <i className="wb webconnect-save-regular"> </i>
                {' Update'}
              </button>
            ) : (
              <button
                className="btn btn-primary btn-md"
                onClick={() => this.handleCreateCollection(index)}
              >
                <i className="wb webconnect-plus"> </i>
                {' Create'}
              </button>
            )}
          </div>
        </div>
      </span>
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { collectionsByDirectus, collectionsByexternaldb } = this.state;
    const { loadExternalDatabaseForDirectusPending, collectionListExternaldbsPending } =
      this.props.dataConnector;
    if (loadExternalDatabaseForDirectusPending || collectionListExternaldbsPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForDirectusPending || collectionListExternaldbsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      collectionsByDirectus && (
        <CommonPageComponent>
          <ParentContentCard title={'All Collections in  Directus Database'} icon={'collection'}>
            <div className="d-flex flex-wrap">
              {collectionsByDirectus &&
                collectionsByDirectus.map((item, index) => {
                  return this.renderCollectionCards(item, index);
                })}
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectusEditPage);
